var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.value
        ? _c("ModalFullScreen", {
            attrs: { size: "xl", title: "Invite Managers" },
            on: { close: _vm.handleCancel },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "ModalTabs",
                        {
                          attrs: { tabs: _vm.tabs },
                          on: { tabIndexUpdated: _vm.updateTabIndex },
                        },
                        [
                          _vm.selectedTabIndex === 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pt-2 border-t-2 border-transparent",
                                },
                                [
                                  _c("ValidationObserver", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ invalid, dirty }) {
                                            return [
                                              _c(
                                                "form",
                                                {
                                                  on: {
                                                    submit: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.invite()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.addingManagersAllowed
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _vm._l(
                                                            _vm.users,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "UserInvitationData",
                                                                {
                                                                  key: index,
                                                                  attrs: {
                                                                    userEmail:
                                                                      item.email,
                                                                    userGivenName:
                                                                      item.givenName,
                                                                    userFamilyName:
                                                                      item.familyName,
                                                                    processing:
                                                                      item.processing,
                                                                    userId:
                                                                      item.id,
                                                                    companyId:
                                                                      _vm.companyId,
                                                                    index:
                                                                      index,
                                                                    userSource:
                                                                      _vm.users,
                                                                    isManager: true,
                                                                    usersToCheck:
                                                                      _vm.invitationTabUsers,
                                                                    allowDelete:
                                                                      _vm.allowDelete,
                                                                  },
                                                                  on: {
                                                                    "update:userEmail":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "email",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-email":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "email",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userGivenName":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "givenName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-given-name":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "givenName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userFamilyName":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "familyName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-family-name":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "familyName",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:processing":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "processing",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:userId":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "id",
                                                                          $event
                                                                        )
                                                                      },
                                                                    "update:user-id":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          item,
                                                                          "id",
                                                                          $event
                                                                        )
                                                                      },
                                                                    delete:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleDeleteRow(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex justify-end mb-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex flex-col items-end",
                                                                },
                                                                [
                                                                  _c(
                                                                    "ManagerInvitationDisabledTooltip",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          !_vm.allowedNumberOfManagersReached,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "UiButton",
                                                                        {
                                                                          staticClass:
                                                                            "m-0",
                                                                          attrs:
                                                                            {
                                                                              variant:
                                                                                "primary",
                                                                              buttonText:
                                                                                "Add",
                                                                              id: "addManager",
                                                                              disabled:
                                                                                _vm.allowedNumberOfManagersReached,
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              _vm.add,
                                                                          },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "icon",
                                                                                  fn: function () {
                                                                                    return [
                                                                                      _c(
                                                                                        "PlusIcon",
                                                                                        {
                                                                                          staticClass:
                                                                                            "w-2.5 h-2.5",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                  proxy: true,
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm.allowedNumberOfManagersReached
                                                                    ? _c(
                                                                        "RouterLink",
                                                                        {
                                                                          staticClass:
                                                                            "text-primary-500 underline",
                                                                          attrs:
                                                                            {
                                                                              to: _vm.managerSubscriptionLink,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Manage subscriptions "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    : !_vm.addingManagersAllowed &&
                                                      _vm.accessAllowedManagersCount >=
                                                        20
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex flex-col justify-center items-center h-36 pb-3 mb-3",
                                                        },
                                                        [
                                                          _c(
                                                            "h4",
                                                            {
                                                              staticClass:
                                                                "text-xl font-semibold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " You have reached maximum number of managers on your subscription. "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "h4",
                                                            {
                                                              staticClass:
                                                                "text-xl font-semibold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "You can add more managers but for an extra cost."
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "UiButton",
                                                            {
                                                              staticClass:
                                                                "mt-6",
                                                              attrs: {
                                                                variant: "pink",
                                                              },
                                                              on: {
                                                                click: () =>
                                                                  _vm.$emit(
                                                                    "openManagerAddonModal"
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "svg",
                                                                    {
                                                                      attrs: {
                                                                        width:
                                                                          "20",
                                                                        height:
                                                                          "20",
                                                                        viewBox:
                                                                          "0 0 20 20",
                                                                        fill: "none",
                                                                        xmlns:
                                                                          "http://www.w3.org/2000/svg",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              d: "M17.875 8.875H11.125V2.125C11.125 1.82663 11.0065 1.54048 10.7955 1.3295C10.5845 1.11853 10.2984 1 10 1C9.70163 1 9.41548 1.11853 9.2045 1.3295C8.99353 1.54048 8.875 1.82663 8.875 2.125V8.875H2.125C1.82663 8.875 1.54048 8.99353 1.3295 9.2045C1.11853 9.41548 1 9.70163 1 10C1 10.2984 1.11853 10.5845 1.3295 10.7955C1.54048 11.0065 1.82663 11.125 2.125 11.125H8.875V17.875C8.875 18.1734 8.99353 18.4595 9.2045 18.6705C9.41548 18.8815 9.70163 19 10 19C10.2984 19 10.5845 18.8815 10.7955 18.6705C11.0065 18.4595 11.125 18.1734 11.125 17.875V11.125H17.875C18.1734 11.125 18.4595 11.0065 18.6705 10.7955C18.8815 10.5845 19 10.2984 19 10C19 9.70163 18.8815 9.41548 18.6705 9.2045C18.4595 8.99353 18.1734 8.875 17.875 8.875Z",
                                                                              fill: "#FFFFFF",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  attrs: {
                                                                    clas: "text-xl",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Add Managers"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "InvitationPlaceholder",
                                                        {
                                                          staticClass:
                                                            "h-36 pb-3 mb-3",
                                                        }
                                                      ),
                                                  _c("ModalSectionsDivider"),
                                                  _vm.addingManagersAllowed
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex pt-5",
                                                        },
                                                        [
                                                          _c("UiButton", {
                                                            staticClass: "mr-3",
                                                            attrs: {
                                                              variant:
                                                                "outline",
                                                              id: "cancelInvite",
                                                              buttonClasses:
                                                                "px-14",
                                                              buttonText:
                                                                "Cancel",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.handleCancel,
                                                            },
                                                          }),
                                                          _c("UiButton", {
                                                            attrs: {
                                                              type: "submit",
                                                              buttonClasses:
                                                                "px-15",
                                                              id: "inviteManager",
                                                              disabled:
                                                                _vm.loading ||
                                                                invalid ||
                                                                !dirty,
                                                              buttonText:
                                                                _vm.loading
                                                                  ? "Loading..."
                                                                  : "Invite",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2942331825
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.selectedTabIndex === 1
                            ? _c(
                                "CsvUploader",
                                {
                                  attrs: {
                                    companyId: _vm.companyId,
                                    csvUploadCompleted: _vm.csvUploadCompleted,
                                    loadingFinished: _vm.uploading,
                                    isManager: true,
                                    usersUnlimited: _vm.managersUnlimited,
                                    availableNumberOfManagers:
                                      _vm.availableNumberOfManagers,
                                  },
                                  on: {
                                    csvUploadUsers: _vm.invite,
                                    close: function ($event) {
                                      return _vm.$emit("input", false)
                                    },
                                    clearCsv: _vm.clearCsv,
                                    wrongExtension: _vm.extensionAlert,
                                    invalidHeaderRow: _vm.invalidHeaderRow,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      _vm.allowedNumberOfCSVManagersReached
                                        ? {
                                            key: "lastParsedCSVLine",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex justify-end mb-2 -mt-4",
                                                  },
                                                  [
                                                    _c(
                                                      "RouterLink",
                                                      {
                                                        staticClass:
                                                          "text-primary-500 underline",
                                                        attrs: {
                                                          to: _vm.managerSubscriptionLink,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Manage subscriptions "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          }
                                        : null,
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.csvParseOutput,
                                    callback: function ($$v) {
                                      _vm.csvParseOutput = $$v
                                    },
                                    expression: "csvParseOutput",
                                  },
                                },
                                [
                                  !_vm.addingManagersAllowed
                                    ? [
                                        _c("InvitationPlaceholder", {
                                          staticClass:
                                            "h-36 pb-2 csv-invitation-placeholder",
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1436535695
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }